import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import type { RootState } from "../store/store";
import { FREELANCER_LOGIN_PAGE } from "../views/auth/routes";
import { isTokenValid } from "../utils/isTokenValid";

type Props = {
  children: React.ReactElement;
};

const FreelancerRoute: React.FC<Props> = ({ children }) => {
  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  // Campo `accessToken`, o mesmo nome que o slice grava (ver BUG-006).
  const token = useSelector((s: RootState) => s.freelancerAuth?.accessToken);

  if (!rehydrated) return null;

  if (!isTokenValid(token)) return <Navigate to={FREELANCER_LOGIN_PAGE()} replace />;
  return children;
};

export default FreelancerRoute;
